module.exports = __webpack_public_path__ + "img/10551392_L.9c600205.png";